import React from 'react'
import LargeStarIcon from "../../../../styles/img/svg/LargeStarIcon"
import PropTypes from 'prop-types';
import BuyIcon from "../../../../styles/img/svg/BuyIcon"
import AddToFavourites from "../../../../styles/img/svg/AddToFavourites"

export default function UiImageCard(props) {
    
    return (
        <>
            <div className='sb-image-card'>
                <img src={props.image}/>
                <div className='sb-image-card__filter'>
                    <div className='sb-image-card__content-wr'>
                        <div className='sb-image-card__content'>
                            <h4>{props.heading}</h4>
                            <div className='sb-image-card__membership-content'>
                                <LargeStarIcon/>
                                <span>{props.ratings} ({props.reviews} reviews) </span>
                            </div>
                        </div>
                    </div>
                </div>
                {props.footer &&
                <div className='sb-image-card__footer'>
                    <div className='sb-image-card__footer-left'>
                        <AddToFavourites />
                        <h6>Add to favourites</h6>
                    </div>
                    <div className='sb-image-card__footer-right'>
                        <BuyIcon />
                        <h6>Buy</h6>
                    </div>
                </div>
                }
            </div>
            
        </>
    )
}

UiImageCard.propTypes = {
    image: PropTypes.string,
    heading: PropTypes.string,
    ratings: PropTypes.string,
    reviews: PropTypes.string
};
